import { useEffect, useState } from 'react';

import { useOneflareClientFeatureManagerService } from 'lib/features/useOneflareClientFeatureManagerService';

export const FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_KEY = 'oneflare-3202-web-djs-full-page-job-form-experiment';
export const FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_PARAMETER = 'redirect_to_full_page';
export const FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_DEFAULT_VALUE = false;
export const useFullPageJobFormRedirectExperiment = (inExperimentalCategory = false) => {
  const [redirectToFullPageJobForm, setRedirectToFullPageJobForm] = useState(FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_DEFAULT_VALUE);
  const featureManager = useOneflareClientFeatureManagerService();
  useEffect(() => {
    if (!inExperimentalCategory) {
      setRedirectToFullPageJobForm(FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_DEFAULT_VALUE);
      return;
    }
    const openFullPageJobForm = featureManager?.getFeatureVariableBoolean(
      FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_KEY,
      FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_PARAMETER,
      FULL_PAGE_JOB_FORM_REDIRECT_EXPERIMENT_DEFAULT_VALUE
    );
    setRedirectToFullPageJobForm(openFullPageJobForm);
  }, [featureManager, inExperimentalCategory]);
  return {
    redirectToFullPageJobForm
  };
};
